import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  Alert,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";
import { getDealList } from "../../../redux/actions/dealActions";
import {
  getVoucherDetail,
  edit_voucher
} from "../../../redux/actions/voucherActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import loader from "../../../style/loader/loader.scss";
import ReactAutocomplete from "react-autocomplete";
import DatePicker from 'react-date-picker';
import "../../../style/react-datetimepicker.scss";
import moment from "moment";
const history = createBrowserHistory();

let isLoading = "false",
  offerdata = {},
  userID = "";
class EditVoucher extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      expiryDate: new Date(),
      voucherID: "",
      voucherValue: "",
      status: (localStorage.getItem("userTypeName") !== "admin") ? 'Redeemed' : '' ,
      path: ["Home", "Voucher List", "Edit Voucher"],
      alertMessage: "",
      show: false,
      disabled: "",
      voucherNumber: "",
      proposal_type: "",
      offer: "",
      note: "",
      redeem_amount: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.Clear = this.Clear.bind(this);
    this.onChangeExpiryDate = this.onChangeExpiryDate.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  validate = () => {
    let isError = false;
    const errors = {};

    if (!this.state.status) {
      isError = true;
      this.setState({ statusError: "red" });
    }

    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();

    if (!err) {
      this.setState({ disabled: true });
      this.handleDismiss();
      this.handleShow();
      const postData = {
        voucherID: this.state.voucherID,
        status: this.state.status,
        note: this.state.note,
        redeem_amount: this.state.redeem_amount,
        voucherValue: this.state.voucherValue,
        expiryDate: this.state.expiryDate ? moment(this.state.expiryDate).format('YYYY-MM-DD') : ""
      };
      this.props.edit_voucher(postData);
    }
  }

  handleChange(e) {
    this.setState({ qtyMessage: "" });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false });
  }

  onChangeExpiryDate = date => {
    this.setState({expiryDate: date});
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.voucherDetails !== nextProps.voucherDetails) {
      if (nextProps.voucherDetails) {
        if (nextProps.voucherDetails.data) {
          isLoading = "false";
        }
        offerdata = nextProps.voucherDetails.data;
        console.log("offerdata =>", offerdata)
        this.setState({
          voucherID: offerdata.voucherID,
          note: offerdata.note,
          offer: offerdata.dealText,
          voucherNumber: offerdata.voucherNumber,
          voucherValue: offerdata.voucherValue,
          proposal_type: offerdata.proposal_type,
          expiryDate: offerdata.expiryDate ? new Date(moment(offerdata.expiryDate).format('YYYY-MM-DD')) : ""
        });
      }
    }

    if (this.props.editVoucherData !== nextProps.editVoucherData) {
      if (nextProps.editVoucherData) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.editVoucherData.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
  }

  Clear() {
    this.state.status = "";
    this.handleDismiss();
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();

    let voucherIdParams = this.props.match.params.voucherID
      ? this.props.match.params.voucherID
      : "";
    userID = this.props.match.params.userID
      ? this.props.match.params.userID
      : "";
    if (voucherIdParams !== "") {
      isLoading = "true";
      this.props.getVoucherDetail(voucherIdParams);
    }
  }

  render() {
    if (offerdata) {
      isLoading = "false";
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">
              Redeem Voucher ({this.state.voucherNumber})
            </header>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOffer">
                      <ControlLabel> {this.state.offer} </ControlLabel>
                    </FormGroup>

                    <FormGroup controlId="formDiscountAmount">
                      <ControlLabel>Notes </ControlLabel>
                      <p>
                        {" "}
                        Feel free to enter notes about this customer (this is
                        optional). It is not a bad idea to include the name of
                        the person redeeming the voucher and their driver's
                        license number. You could also include things like the
                        total from the customer's bill or their email address,
                        et cetera.
                      </p>
                      <FormControl
                        componentClass="textarea"
                        value={this.state.note}
                        placeholder="Notes"
                        onChange={this.handleChange}
                        name="note"
                      />
                    </FormGroup>

                    <FormGroup controlId="formOffer">
                      <ControlLabel> Voucher Value </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.voucherValue}
                        placeholder="Voucher Value"
                        onChange={this.handleChange}
                        name="voucherValue"
                      /> 
                    </FormGroup>

                    <FormGroup controlId="formOffer">
                      <ControlLabel> Expiry Date</ControlLabel> 
                      <DatePicker
                        onChange={this.onChangeExpiryDate} 
                        value={this.state.expiryDate}
                      />
                    </FormGroup>

                    <FormGroup controlId="formCoupanForGifts">
                      <ControlLabel>Status</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="status"
                        value={this.state.status}
                        style={{ borderColor: this.state.statusError }}
                        onChange={this.handleChange}
                      >
                        <option value="">Select</option>
                        {(localStorage.getItem("userTypeName") !== "admin" || localStorage.getItem("userTypeName") !== "subadmin") ? 
                        <option value="Void">Void</option>
                        : '' }
                        {(localStorage.getItem("userTypeName") !== "admin" || localStorage.getItem("userTypeName") !== "subadmin") ? 
                        <option value="Active">Active</option>
                        : ''}
                        <option value="Redeemed">Redeemed</option>
                      </FormControl>
                    </FormGroup>
                    {(this.state.proposal_type === '8') &&
                      <FormGroup>
                        <ControlLabel>Redeem Amount</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.redeem_amount}
                          placeholder="Enter Amount"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.redeem_amount}}
                          name="redeem_amount"
                          autoComplete="off"
                          required
                        />
                      </FormGroup>
                    }
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="submit"
                id="saveButton"
                disabled={this.state.disabled}
              >
                Save Voucher{" "}
              </Button>
              {(localStorage.getItem("userTypeName") === "merchant") ? (
                <Button
                  bsStyle="default"
                  onClick={() =>
                    this.context.router.history.push(`/merchant/voucher/list/${userID}`)
                  }
                >
                  Cancel
                </Button>
              ) : (
                <Button
                  bsStyle="default"
                  onClick={() => this.context.router.history.push(`/voucherList`)}
                >
                  Cancel
                </Button>
              )}
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dealList: state.dealReducer.dealList,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    voucherResponse: state.voucherReducer.voucherResponse,
    offerslist: state.voucherReducer.offerslist,
    error: state.voucherReducer.error,
    emailResponse: state.voucherReducer.emailResponse,
    autoEmailData: state.voucherReducer.autoEmailData,
    checkQty: state.voucherReducer.checkQty,
    voucherDetails: state.voucherReducer.voucherDetails,
    editVoucherData: state.voucherReducer.editVoucherData
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    getVoucherDetail,
    renderAlert,
    clearAlert,
    edit_voucher
  })
)(EditVoucher);



// WEBPACK FOOTER //
// ./src/app/views/merchant/voucher/EditVoucher.js